import Quote from './Quote';

export const QuotePage = Quote;
export { default as AddQuotePage } from './AddQuote';

export default Quote;
